import React, { Component } from 'react';
import {Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import { VisibilityRounded } from '@material-ui/icons';
import moment from 'moment';

export default class OHSQualSubform extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {  
            writing: false,
            error: false,
            error_message: '',
            querying: true,
            matrix_array: [],
        };

        this.state = this.initial_state;

        this.datasheetFieldSpecs = [
            { field: 'select', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.selectQual(parms)} 
                    color='primary'
                    variant='outlined'
                    disabled={moment().diff(parms.row.expires,'days')>0}
                >
                    Select
                </Button>
            )},
            // { field: 'id', headerName: 'Empl. #', width: 90, sortable:false},
            { field: 'qualification_type', headerName: 'Qualification Type', width: 350, sortable:false},
            // { field: 'qual_discipline', headerName: 'Academic Discipline', width: 210, sortable:false},
            { field: 'description', headerName: 'Description', width: 150, sortable: false},
            { field: 'nqf_level', headerName: 'NQF level', width: 75, align:'center', sortable:false},
            { field: 'year_obtained', headerName: 'Year Obtained', width: 100, align:'center'},
            { field: 'expires', headerName: 'Expires?', width: 120,
            renderCell: (parms) => (
                (parms.row.expires)&&
                <span style={{color: -moment().diff(parms.row.expires,'days') < 1 ? '#FF0000' : -moment().diff(parms.row.expires,'days') < 30 ? '#FF9900' : ''}}>{parms.row.expires}</span>
            )},
            { field: 'file_attachment', headerName: 'Document Attached', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.file_attachment==="YES")&&
                <IconButton
                    onClick={()=>this.viewDoc(parms)} 
                >
                    <Tooltip title="View Document Attachment">
                        <VisibilityRounded/>
                    </Tooltip>
                </IconButton>
            )},
            // { field: 'comment', headerName: 'Comment', width: 250, sortable:false}
        ]
   
    }

    componentDidMount = () => {
        Gserv.sendCommand('query_employee_ohs_qualifications',this.props.gwt,{
            employee_number: this.props.employee_number
        })
        .then(reply=>{
            // console.log('query_employee_qualifications reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_employee_ohs_qualifications) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_employee_ohs_qualifications) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({querying:false, matrix_array:reply.Records? reply.Records : []});
            }
        });
    };

    viewDoc = (parms) => {
        // console.log('parms.row :>> ', parms.row);
        this.setState({querying:true});
        Gserv.sendCommand('query_qualification_attachment',this.props.gwt,{
            file_key: parms.row.file_key
        })
        .then(file_url => {
            // console.log('file_url obj returned :>> ', file_url);
            if (file_url.error){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (file_url.Result!=="Success"&&file_url.statusCode!==204){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                window.open(file_url.Url, '_blank', 'noopener,noreferrer');
                // const newWindow = window.open(file_url.Url, '_blank', 'noopener,noreferrer');
                // if (newWindow) newWindow.opener = null
            }
            this.setState({querying:false})
        }); 
    }

    selectQual = (qual) => {
        // console.log('qual :>> ', qual);
        this.props.setParentState({qual_link: qual.id, qual_obj: qual.row});
    }

    resetMe = () => {
        this.setState(this.initial_state);
        this.componentDidMount();
    }

    skipMe = () => {
        if (window.confirm("Are you sure you wish to continue with this OHS appointment without linking an OHS certificate? This OSH appointment will reflect as non-compliant straight away.")){
            this.props.setParentState({qual_link:'', qual_obj: {id:0, skipped:true}});
        }
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                style={{width:1025}}
            >

                <div>
                    <Typography style={{padding:15}}>
                        This OHS role requires the appointee to have a relevant OHS certificate or qualification. <b>Please select the OHS certificate or qualification</b> from the list below, which is applicable in respect of this appointment.
                    </Typography>
                    <hr/>
                    <Typography style={{textAlign:'left', marginBottom:5}}>
                        &nbsp;OHS related certificates and qualifications on record for #{this.props.employee_number} <b>{this.props.employee_name}</b>:
                    </Typography>                
                    <DatasheetView
                        dataset={this.state.matrix_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        loading={this.state.querying}
                        deleteHeaderName={'Delete Qualification'}
                        pagesize={8}
                    />
                </div>

                {this.state.querying===false&&this.state.matrix_array.length===0&&
                <Typography style={{padding:15}}>
                    <i>There are no OHS certificates or qualifications on file yet for this employee.</i>
                </Typography>}

                {this.props.allow_skip&&
                <Grid container justifyContent='flex-end'>    
                    <Button
                        variant='outlined'
                        // color='primary'
                        // type='submit'
                        style={{marginTop:'15px',marginBottom:'15px', marginRight:'15px'}}
                        onClick={this.skipMe}
                    >
                        Skip Linking of Certification
                    </Button>
                </Grid>}

                <Grid item>
                    <Typography color='secondary' style={{Width:1025,maxWidth:1025, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

            </Grid>
        );
    }
    
}